import React, { useRef, useState } from "react";
import "./product-list-detail.scss";
import "../message/message.scss";
import { postMessageToClient } from "../chatservice/communicationService";
import { DialogflowQueryType } from "../models/enum";
import { dialogflowEvent } from "../../config/config";
import { updateAnalyticsStatus } from "../chatservice/dialogflowQuery";

interface IProduct {
  tags: string[];
  price: number,
  wasPrice: number,
  isAppBasedOffer?: boolean;
  [key: string]: any;
}

type ProductListDetailProps = {
  sessionId: any;
  userId: any;
  product: IProduct;
  selectedStore: any;
  quickReplyHandler: any;
  toggleWidget: any;
  isWebView: boolean;
};

const formImageUrl = (url: string) => {
  return url.substring(url.lastIndexOf("/") + 1);
};

const getInventoryStatus = (product: any) => {
  // const packTypeToShow = getPackType(product);
  // if (packTypeToShow.Key === 'Bottle') {
  //     return `${product?.availableInventoryQty} ${packTypeToShow.DisplayName} at ${formatStoreName(product.storeName)}`;
  // }
  return `${product.stockOnHand}`;
  //return `${Math.ceil(product?.availableInventoryQty / packTypeToShow.UnitQty)} ${packTypeToShow.DisplayName} of ${packTypeToShow.UnitQty} at ${formatStoreName(product.storeName)}`;
};

const formatStoreName = (storeName: any) => {
  const store = storeName.replaceAll("BWS ", "");
  return store.charAt(0).toUpperCase() + store.slice(1).toLowerCase();
};

const isMarketPlaceProduct = (product: any) => {
  return product?.stockCode?.startsWith("ER_");
};

const isMemberOffer = (product: any) => {
  return product?.tags?.find((a:any) => a.indexOf('memberprice') >= 0) !== null;
};

const isSuperSaver = (product: any) => {
  return product?.tags?.find((a:any) => a.indexOf('memberprice') >= 0) !== null;
};



const ProductListDetail = ({
  sessionId,
  userId,
  product = {} as IProduct,
  selectedStore,
  quickReplyHandler,
  toggleWidget,
  isWebView,
}: ProductListDetailProps) => {
  const [isDelivery, setIsDelivery] = useState<boolean>(
    selectedStore.isDeliveryEnabled
  );
  const [isPickup, setIsPickup] = useState<boolean>(
    selectedStore.isClickAndCollectEnabled
  );
  const [isDriveThrough, setIsDriveThrough] = useState(
    selectedStore.facilities.includes("Drive Thru")
  );

  let isMemberOffer: boolean = false;
  let isSuperSaver: boolean = false;
  let isLowPriceEveryday: boolean = false;
  let isClearance: boolean = false;
  let isAppyDeals: boolean = false;
  
  // NOTE: this logic could render multiple offer tags
  // where as in web, the logic will only read the 1st item in 'tags' array.
  product?.tags?.forEach((tag:any) => {
    const _tag = tag.toLowerCase();
    if (_tag.indexOf('memberprice') >= 0) 
    { 
      isMemberOffer = true;
    }
    else if (_tag.indexOf('super-savers') >= 0) 
    {
      isSuperSaver = true; 
    }
    else if (_tag.indexOf('low-prices') >= 0) 
    {
      isLowPriceEveryday = true;
    }
    else if (_tag.indexOf('clearance') >= 0) 
    { 
      isClearance = true;
    }
    else if ((_tag.indexOf('appy-deals') >= 0)) 
    { 
      // additional check due to API and UI feature toggle difference
      if ((product.savingsAmount > 0) && product.isAppBasedOffer) {
        isAppyDeals = true;
      }
    }
  });

  // product.isAppBasedOffer is set via config during deployment. It is not a feature toggle.
  // The API has feature toggle and therefore 'product.isAppBasedOffer' is unreliable
  // product.isAppBasedOffer could be true, but in fact is not without 'appy-deals' image tag
  // if isAppBasedOffer is false then regardless of the appy-deals image tag
  if (!product.isAppBasedOffer) {
    isAppyDeals = false;
  }

  const fileName = formImageUrl(product.images?.small);
  let stockText = "";

  if (isMarketPlaceProduct(product)) {
    //Market place products
    stockText = "Delivery only";
  } else if (
    product.isDeliveryOnly ||
    parseInt(product?.availableInventoryQty ?? 0) <= 0
  ) {
    stockText = "0";
  } else {
    stockText = getInventoryStatus(product);
  }

  const prodDetailsUrl = `/product/${product.stockCode}/${product.urlFriendlyName}`;
  
  const onMoreDetailsClickHandler = (e: any) => {
    const analyticsCall = {
      data: {
        linkName: `web:chatbot:product availability:more details:${product.productName}`,
        linkType: "chatbot product availability",
      },
      methodHandler: "chatbotTriggerAdobeAnalytics",
    };
    postMessageToClient(analyticsCall);

    // init change url
    const objCall = {
      data: {
        prodDetailsUrl: prodDetailsUrl,
        storeId: product.storeId,
        storeName: formatStoreName(product.storeName),
        queryString: { i_cid: "cbprodavail" },
      },
      methodHandler: "chatbotInitChangeUrl",
    };
    // minimize widget
    toggleWidget(false);
    postMessageToClient(objCall);

    // post message to chatserver, change analytics status to success
    updateAnalyticsStatus(sessionId, userId, product.intentGroupId, true);
  };

  const onNearbyStoreClickHandler = (e: any) => {
    const params: any = {
      suburb: selectedStore.suburb,
      postcode: selectedStore.postCode,
      productData: {
        productName: product.productName,
        stockCode: product.stockCode,
        productDetailsUrl: prodDetailsUrl,
        availablePackTypes: product.availablePackTypes,
      },
      state: selectedStore.state,
      selectedStoreId: selectedStore.storeId,
    };
    quickReplyHandler(
      e,
      DialogflowQueryType.Event,
      dialogflowEvent.PRODUCT_AVAIL_FIND_NEARBY_STORES,
      false,
      params
    );
  };

  let displayPrice = product.price || 0;

  if (isAppyDeals) {
    displayPrice = product.wasPrice;
  }

  function getProductPromotionTag() {
    if (!isAppyDeals) {
      return (
        <>
          { isMemberOffer && <span className="product__pretext--memberoffer">Everyday Rewards Exclusive Member Pricing</span> }
          { isSuperSaver && <span className="product__pretext--supersaver">SUPER SAVERS</span> }
          { isClearance && <span className="product__pretext--clearance">CLEARANCE</span> }
          { isLowPriceEveryday && <div><span className="product__pretext--lowprices">LOW PRICES</span>&nbsp;<span className="product__pretext--everyday">EVERYDAY</span></div> }
        </>
      );
    }

    return null;
  }

  function getPriceMessage() {
    const {
      price = 0,
      wasPrice = 0
    } = product;

    let ret = '';

    if (wasPrice > price) {
      ret = `Was ${wasPrice.toFixed(2)}`;
    }
    return ret;
  }

  function getAppyDealPrice() {
    const {
      wasPrice = 0,
      savingsAmount = 0,
    } = product;
    return (wasPrice - savingsAmount).toFixed(2);
  }

  return (
    <div className="product">
      <div className="product__details">
        <div className="product__image">
          <img
            src={`https://edgmedia.bws.com.au/bws/media/products/${fileName}?impolicy=Prod_SM`}
            alt="product"
          />
        </div>

        <div className="product__title">
          <span className="product__title-name">{product.productBrand}</span>
          <span className="product__title-description">{product.productName}</span>
        </div>

        {product.isDeliveryOnly && !isMarketPlaceProduct(product) && (
          <p className="product__deliveryText">Available for delivery</p>
        )}
        {displayPrice > 0 && (
          <div className="product__pretext">
              {getProductPromotionTag()}
          </div>
        )}
        {displayPrice > 0 && (
          <div className="product__priceContent">
            <div className="product__price">
              <span className="product__price--prefix">$</span>
              <span className="product__price--value">{ Math.trunc(displayPrice)}</span>
              <span className="product__price--postfix">{ (displayPrice).toFixed(2).split('.')[1] }</span>
            </div>

            {!isAppyDeals && (
              <span className="product__price--message">
                {getPriceMessage()}
              </span>
            )}

            {isAppyDeals && (
              <div className="product__secondaryprice product__secondaryprice--appy-deals">
                APPY DEALS ${getAppyDealPrice()}
              </div>
            )}

            {(product.isOnlineOffer || product.isMemberOffer) && (product.nonMemberPrice > 0) && (
              <div className="product__secondaryprice">
                Non-Member ${product.nonMemberPrice.toFixed(2)}{" "}
              </div>
            )}
          </div>
        )}


        {product?.availableInventoryQty !== 0 && (product?.isDisplayOnly === null || (product?.isDisplayOnly !== null && product?.isDisplayOnly === false)) ? (
          <div>
            <div className="product__stock">
              <span>{product?.availableInventoryQty}</span> units are available at{" "}
                {product.storeName.slice(4)}
            </div>
            <div className="product__facilities">
              {isDelivery ? (
                <div className="delivery">
                  <img className="product__facilities-isAvailable" src="/images/Vector-correct.svg" alt="" />
                  <span> Delivery</span>
                </div>
              ) : (
                ""
              )}
              {isPickup ? (
                <div className="pickUp">
                  <img className="product__facilities-isAvailable" src="/images/Vector-correct.svg" alt="" />
                  <span> Pick up</span>
                </div>
              ) : (
                ""
              )}

              {isDriveThrough ? (
                <div className="driveThrough">
                  <img className="product__facilities-isAvailable" src="/images/Vector-correct.svg" alt="" />
                  <span> Drive through</span>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        ) : (
          <div>
            <div className="product__outofstock"><img src="/images/Vector-x.svg" alt="" /> <span>out of stock at{" "}{product.storeName}</span> 
            </div>
            <div className="product__facilities"></div>
          </div>
        )}
      </div>

      <div className="product__options">
        {!isWebView && (
          <div className="product__options-viewDetails">
            <a
              className="product__options__text--click"
              onClick={onMoreDetailsClickHandler}
              id="more-details-link"
            >
                view details{" "}
              <img src="/images/Vector-link-icon.svg" alt="" />{" "}
            </a>
          </div>
        )}
        {!isMarketPlaceProduct(product) && (
          <div className="product__options-nearBy">
            <span
              className="product__options__text--click"
              onClick={onNearbyStoreClickHandler}
              id="find-nearby-link"
            >
              Find nearby
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export { ProductListDetail };
